// extracted by mini-css-extract-plugin
module.exports = {"appScreen":"EmptyLayout_app-screen__3WjUN","appName":"EmptyLayout_app-name__1KYBz"};